import styled from 'styled-components';

import { ContentAuth } from '../../../styles/common/auth';

export const TitleStyled = styled.h2`
  color: var(--white);
  text-align: center;
  font-size: 25px;
`;

export const ContentStyled = styled(ContentAuth)`
  h2,
  p {
    text-align: center;
    color: var(--gray-200);
  }

  svg {
    color: var(--gray-200);
  }

  h2 {
    font-size: 22px;
    margin: 10px 0 0;
  }

  p {
    font-size: 14px;
    margin-bottom: 20px;
  }

  a {
    margin-bottom: 10px;
    align-self: flex-start;
  }
`;
